module.exports = __webpack_public_path__ + "img/nav_nation.ae003118.jpg";